import { render, staticRenderFns } from "./nonstandardDetail.vue?vue&type=template&id=7ffa8434&scoped=true"
import script from "./nonstandardDetail.vue?vue&type=script&lang=js"
export * from "./nonstandardDetail.vue?vue&type=script&lang=js"
import style0 from "./nonstandardDetail.vue?vue&type=style&index=0&id=7ffa8434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa8434",
  null
  
)

export default component.exports